var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.231-200h-84.616q-26.654 0-45.634-18.981Q120-237.961 120-264.615v-430.77q0-26.654 18.981-45.634Q157.961-760 184.615-760H760v40H184.615q-10.769 0-17.692 6.923T160-695.385v430.77q0 10.769 6.923 17.692T184.615-240h84.616v40Zm166.154-75.385q25 0 42.5-17.5t17.5-42.5q0-25-17.5-42.5t-42.5-17.5q-25 0-42.5 17.5t-17.5 42.5q0 25 17.5 42.5t42.5 17.5ZM380-200v-57.923q-18.231-13.154-29.116-33.461Q340-311.692 340-335.385q0-23.692 10.884-44 10.885-20.307 29.116-33.461v-57.923h110.769v57.923q18.231 13.154 29.116 33.461 10.884 20.308 10.884 44 0 23.693-10.884 44.001-10.885 20.307-29.116 33.461V-200H380Zm427.693 0H633.846q-13.731 0-23.019-9.288-9.289-9.289-9.289-23.019v-335.385q0-13.731 9.289-23.02Q620.115-600 633.846-600h173.847q13.73 0 23.019 9.288 9.288 9.289 9.288 23.02v335.385q0 13.73-9.288 23.019Q821.423-200 807.693-200Zm-166.154-40H800v-320H641.539v320Zm0 0H800 641.539Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.1089132a59d873669bb1d0f4bba5ed39.svg";
export { ForwardRef as ReactComponent };